import { Injectable } from '@angular/core';
import { APISCockpit } from 'src/service/apis-cockpit';
import { TaskItem } from '../../taskcommon/taskcommon.class';
import { TaskContract } from './taskcontract';

const API = '/api/construction-projects/v1/cockpit-taskcontracts/';

@Injectable({ providedIn: 'root' })
export class TaskContractService {

  taskContract: TaskContract = new TaskContract();
  taskContracts: TaskContract[] = [];

  constructor(private apiCockpit: APISCockpit) { }

  async GetInfoTask(itm: TaskItem) {
    if (typeof(itm?.companyid) !== 'undefined') {
      const url: string = API + itm.id;
      this.taskContracts = (await this.apiCockpit.getDataInfo(url)).items;
      if (this.taskContracts.length > 0) {
        this.taskContract = this.taskContracts[0];
      }
    }
    return this.taskContract;
  }

  async GetInfoTaskByInput(itm: TaskItem) {
    if (typeof(itm?.companyid) !== 'undefined') {
      const url: string = API + itm.id + '/byinput/' + itm.inputId;
      this.taskContracts = (await this.apiCockpit.getDataInfo(url)).items;
      if (this.taskContracts.length > 0) {
        this.taskContract = this.taskContracts[0];
      }
    }
    return this.taskContract;
  }

}
